appSocial.component('leaderPause', {
    templateUrl: 'widgets/leader-copy/components/leader-pause/LeaderPauseComponent.html',
    bindings: {
        trader: '<',
        action: '<',
        onSuccess: '&',
        onStart: '&',
        onFail: '&'
    },
    controller: [
        '$scope',
        'SocialUserService',
        'SocialLocaleService',
        'SocialFavoriteService',
        'SocialPortfolioService',
        'SocialUtils',
        'SocialConstants',
        'SocialTypes',
        'LeaderCopyService',
        '$timeout',
        '$filter',
        class LeaderPauseComponent {
            constructor(
                $scope,
                SocialUserService,
                SocialLocaleService,
                SocialFavoriteService,
                SocialPortfolioService,
                SocialUtils,
                SocialConstants,
                SocialTypes,
                LeaderCopyService,
                $timeout,
                $filter
            ) {

                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {SocialFavoriteService}
                 */
                this.favoriteService = SocialFavoriteService;

                /**
                 * @type {SocialPortfolioService}
                 */
                this.portfolioService = SocialPortfolioService;

                /**
                 * @type {LeaderCopyService}
                 */
                this.leaderCopyService = LeaderCopyService;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                this.actions = SocialTypes.CopyAction;

                this.$timeout = $timeout;

                this.currencyConvertPipe = $filter('currencyConvert');
                this.currencyPipe = $filter('cryptoCurrency');

                this.translation = SocialLocaleService.translation;

                this.user = this.userService.get();

                this.defaultAmount = 1000;

                this.amount = {
                    value: this.defaultAmount
                };

                this.watchAddAction = $scope.$on('pauseCopy', () => this.callAction('pauseCopy'));
                this.watchRemoveAction = $scope.$on('resumeCopy', () => this.callAction('resumeCopy'));
            }


            $onInit() {
                this.amountConfig = {
                    min: 0,
                    max: 1200,
                    digits: 2,
                    step: 50,
                    label: 'Total Current Amount',
                    buttons: false,
                    readonly: true
                }

                this.amount.value = this.calcAmount();
            }

            $onDestroy() {
                this.watchAddAction && this.watchAddAction();
                this.watchRemoveAction && this.watchRemoveAction();
            }

            callAction(action) {
                this.onStart();
                return this.leaderCopyService.updateState(this.trader.followId, action === this.actions.Resume)
                    .then(() => {
                        this.onSuccess();
                    })
                    .catch(err => {
                        this.onFail({error: err});
                    });
            }

            calcAmount() {
                return this.currencyConvertPipe(this.trader.followDeposit + this.trader.followPnl, this.user.currency, 'USD');
            }

        }]
})
